import React from 'react';

const YogaServiceCard = ({ service }) => {
    const renderPricing = () => {
        if (service.priceType === 'inquire') {
            return (
                <div className="flex items-center text-gray-700">
                    <svg className="w-6 h-6 mr-4 text-sage-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                    </svg>
                    <div>
                        <span className="text-lg font-semibold text-sage-600">Contact for pricing</span>
                    </div>
                </div>
            );
        }

        if (!service.price) return null;

        return (
            <div className="flex items-start text-gray-700">
                <div className="flex-1">
                    {service.priceType === 'per-person' ? (
                        <div>
                            <span className="text-2xl font-bold text-sage-600">${service.price}</span>
                            <span className="ml-2 text-gray-600">per person</span>
                        </div>
                    ) : service.priceType === 'flat' ? (
                        <div>
                            <span className="text-2xl font-bold text-sage-600">${service.price}</span>
                            <span className="ml-2 text-gray-600">flat fee</span>
                        </div>
                    ) : service.priceType === 'tiered' ? (
                        <div className="space-y-1">
                            <div>
                                <span className="text-2xl font-bold text-sage-600">${service.price}</span>
                                <span className="ml-2 text-gray-600">
                                    for up to {service.baseCapacity || 10} {service.baseCapacity === 1 ? 'person' : 'people'}
                                </span>
                            </div>
                            {service.additionalPrice && (
                                <div className="text-gray-600 ml-0">
                                    <span className="font-semibold">${service.additionalPrice}</span> per additional guest
                                </div>
                            )}
                        </div>
                    ) : (
                        <span className="text-2xl font-bold text-sage-600">${service.price}</span>
                    )}
                </div>
            </div>
        );
    };

    return (
        <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-0">
                {/* Image Section - Fixed aspect ratio */}
                <div className="relative aspect-[4/3] md:aspect-square">
                    {service.image ? (
                        <img
                            src={service.image}
                            alt={service.title}
                            className="absolute inset-0 w-full h-full object-cover"
                        />
                    ) : (
                        <div className="absolute inset-0 w-full h-full bg-gradient-to-br from-purple-400 to-pink-400 flex items-center justify-center">
                            <span className="text-white text-8xl">{service.icon || '🧘'}</span>
                        </div>
                    )}
                </div>

                {/* Content Section */}
                <div className="p-8 md:p-12 flex flex-col justify-center">
                    <h3 className="text-3xl font-semibold text-gray-900 mb-8">{service.title}</h3>

                    <div className="space-y-6 mb-8">
                        {service.duration && (
                            <div className="flex items-center text-gray-700">
                                <svg className="w-6 h-6 mr-4 text-sage-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                <div>
                                    <span className="font-semibold text-lg">Duration:</span>
                                    <span className="ml-2 text-lg">{service.duration}</span>
                                </div>
                            </div>
                        )}

                        {renderPricing()}
                    </div>

                    {/* Improved description styling */}
                    <div className="prose prose-lg max-w-none">
                        <p className="text-gray-700 leading-loose text-lg font-light">
                            {service.description}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default YogaServiceCard;